<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 27 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.22233 21.3333C1.62233 21.3333 1.10189 21.113 0.661 20.6723C0.220333 20.2314 0 19.711 0 19.111V2.22233C0 1.62233 0.220333 1.10189 0.661 0.661001C1.10189 0.220334 1.62233 0 2.22233 0H24.4443C25.0443 0 25.5648 0.220334 26.0057 0.661001C26.4463 1.10189 26.6667 1.62233 26.6667 2.22233V19.111C26.6667 19.711 26.4463 20.2314 26.0057 20.6723C25.5648 21.113 25.0443 21.3333 24.4443 21.3333H2.22233ZM13.3333 11.511L2.22233 4.33333V19.111H24.4443V4.33333L13.3333 11.511ZM13.3333 9.289L24.3557 2.22233H2.33333L13.3333 9.289ZM2.22233 4.33333V2.22233V19.111V4.33333Z"
      :fill="color"
    />
  </svg>
</template>
<script>
export default {
  props: {
    color: {
      type: String,
      default: "#3E3B39",
    },
    size: {
      type: Number,
      default: 24,
    },
  },
};
</script>
